import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 자원 계획 결과(공장>스테이지>자원>공정그룹>공정별 크로스탭) — AnalysisController#getResrcPlanResults.
// getPlanResults와 달리 changes(필터) 자체를 백엔드가 안 읽으므로 postParams만 쓴다
// (fp-report-screen-guide.md §A-3e — "resrc-plan-result는 params만").
const getResrcPlanResults = (params) => fpApiUtil.postParams(`${ANALYSIS}/resrc-plan-result`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/stageCd/resourceCd/routeGrpCd/
// routeCd)으로 드릴다운, useGrouping:true로 그 레벨까지 백엔드가 집계해서 1행만 내려준다.
const getResrcPlanResultChart = (params) => fpApiUtil.postParams(`${ANALYSIS}/resrc-plan-result`, params);

const fpResrcPlanResultService = { getResrcPlanResults, getResrcPlanResultChart };
export default fpResrcPlanResultService;
